import { a as n, j as e } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { useState as l, useLayoutEffect as G } from "react";
import { IonLabel as R, IonHeader as V, IonInput as D, IonItem as F } from "@ionic/react";
import { Colors as O } from "../../1-foundations/Colors/Colors.js";
import { I as M } from "../../../Icon-IZV2yalv.js";
import { c as N, P as E, h as T, w as W, b as H } from "../../../FeatureFlagProvider-Dk-Rz1cD.js";
import { translate as a } from "../../string-table.js";
import "../../../react-paginate-Lh5zQzpz.js";
import "../LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function ee(i) {
  const {
    app: r,
    history: t,
    location: d,
    loginPath: m,
    onSignUp: A
  } = i, s = d.state, [p, P] = l(""), [u, b] = l(""), [o, v] = l(""), [h, x] = l(""), f = /[A-Z]/.test(o), L = /[a-z]/.test(o), _ = /\d/.test(o), I = o.length >= 8, S = p && u && f && L && _ && I && o === h;
  G(() => {
    if (!s || !s.email)
      return t.push("/");
  }, [t, s]);
  const U = ({
    firstName: B,
    lastName: C,
    email: k,
    password: y
  }) => {
    A({
      firstName: B,
      lastName: C,
      email: k,
      password: y
    });
  };
  if (!(s != null && s.email)) return;
  const g = s.email;
  return /* @__PURE__ */ n(W, {
    app: r,
    title: a("SIGN_UP_PAGE_HEADER_LABEL"),
    onBackNav: () => {
      t.push({
        pathname: m,
        state: {
          email: g
        }
      });
    },
    children: [/* @__PURE__ */ e("p", {
      css: {
        ...N({
          fontWeight: 600
        })
      },
      children: a("SIGN_UP_HEADER_LABEL")
    }), /* @__PURE__ */ n("div", {
      css: {
        display: "flex",
        flexDirection: "column",
        gap: 8
      },
      children: [/* @__PURE__ */ n("div", {
        css: {
          paddingLeft: 16
        },
        children: [/* @__PURE__ */ e("p", {
          css: {
            ...N({
              fontWeight: 600
            })
          },
          children: a("EMAIL_FIELD_LOGIN_INPUT_PLACEHOLDER")
        }), /* @__PURE__ */ e("p", {
          children: s == null ? void 0 : s.email
        })]
      }), /* @__PURE__ */ e(w, {
        label: a("SIGN_UP_FIRST_NAME_LABEL"),
        value: p,
        setValue: P
      }), /* @__PURE__ */ e(w, {
        label: a("SIGN_UP_LAST_NAME_LABEL"),
        value: u,
        setValue: b
      }), /* @__PURE__ */ e(E, {
        password: o,
        onPasswordInput: v,
        passwordLabel: a("SIGN_UP_PASSWORD_LABEL")
      }), /* @__PURE__ */ e(E, {
        password: h,
        onPasswordInput: x,
        passwordLabel: a("SIGN_UP_CONFIRM_PASSWORD_LABEL")
      }), /* @__PURE__ */ n("div", {
        css: {
          background: "var(--swing-slate200)",
          margin: "16px 0",
          padding: "8px 4px 12px 12px",
          borderRadius: 6
        },
        children: [/* @__PURE__ */ e("p", {
          css: {
            margin: "4px 0"
          },
          children: "All passwords must have:"
        }), /* @__PURE__ */ e(c, {
          isValid: f,
          children: "1 uppercase character"
        }), /* @__PURE__ */ e(c, {
          isValid: L,
          children: "1 lowercase character"
        }), /* @__PURE__ */ e(c, {
          isValid: _,
          children: "1 number"
        }), /* @__PURE__ */ e(c, {
          isValid: I,
          children: "8 characters minimum"
        })]
      }), /* @__PURE__ */ e(T, {
        type: "secondary",
        onClick: () => {
          console.log("woot kwan"), U({
            firstName: p,
            lastName: u,
            email: g,
            password: o
          });
        },
        isFluid: !0,
        status: S ? "enabled" : "disabled",
        children: a("SIGN_UP_BUTTON_LABEL")
      })]
    })]
  });
}
function c(i) {
  const {
    children: r,
    isValid: t
  } = i;
  return /* @__PURE__ */ n("div", {
    css: {
      display: "flex",
      gap: 4,
      opacity: t ? 1 : 0.3
    },
    children: [/* @__PURE__ */ e(M, {
      name: t ? "Check" : "Close"
    }), r]
  });
}
function w(i) {
  const {
    value: r,
    setValue: t,
    label: d
  } = i;
  return /* @__PURE__ */ n("div", {
    children: [/* @__PURE__ */ e(V, {
      className: "ion-padding-start ion-no-border",
      children: /* @__PURE__ */ e(R, {
        position: "stacked",
        css: {
          ...H({
            fontWeight: 500
          })
        },
        children: d
      })
    }), /* @__PURE__ */ e(F, {
      lines: "full",
      css: {
        width: "100%",
        "--ion-item-background": "var(--ion-color-light)",
        background: "var(--ion-color-light)",
        "--border-color": O.slate400,
        "--min-height": "auto"
      },
      children: /* @__PURE__ */ e(D, {
        type: "text",
        value: r,
        css: {
          flex: 1
        },
        id: "fname",
        onIonInput: (m) => {
          t(m.detail.value);
        },
        spellCheck: "false",
        autocomplete: "one-time-code"
      })
    })]
  });
}
export {
  ee as SignUp
};
